import { render, staticRenderFns } from "./RoutesIndex.vue?vue&type=template&id=26ae8f8c"
import script from "./RoutesIndex.vue?vue&type=script&lang=js"
export * from "./RoutesIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports